/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowCustom = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowCustom = $.extend(this, window.PXUTheme.getSectionData($section));
    
    // Selectors
    const $slideshowCustomEl = $section.find('[data-slideshow-custom]').removeClass('is-hidden');
    
    const $slideshowCustom = $slideshowCustomEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1,
      pageDots: this.number_of_slides > 1,
      draggable: true,
      initialIndex: this.initial_slide_index,
      selectedAttraction: 0.2,
      friction: 0.8,
      arrowShape: { 
        x0: 10,
        x1: 50, y1: 50,
        x2: 70, y2: 50,
        x3: 30
      }
    });

    // Resize flickity when the slider is settled
    $slideshowCustomEl.on( 'settle.flickity', function() {
      $slideshowCustomEl.flickity('resize');
    })

  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-slideshow-custom]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');
    $slider.flickity('select', $sliderIndex, true, true);

  },
  unload: function($section) {

  }
}

/******/ })()
;